import { WcsApiService } from "../services/wcs-api-service";


export class SAEBaseComponent {
    public wcsdata: any;
    public segmentMap: any;
    constructor(public wcsApiService: WcsApiService) {
    }
    async loadWCSData(pageRoute: string) {
        try {
            this.wcsdata = await this.wcsApiService.getWcsContent(pageRoute).toPromise();
            this.wcsdata = JSON.parse(this.wcsdata);
        } catch (error: any) {
            console.error('Error loading WCS data:', error.message);
        }
    }
    public scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
}